module.exports = __webpack_public_path__ + "static/david.transom-478a6c3a2977e3dbec02c23150859738.jpg";